import { useDomainTheme } from '../components';
import { LinkResource } from '../types';

export const useResourceLoader = (resources: LinkResource[]): void => {
  const { domainTheme } = useDomainTheme();
  const build = import.meta.env.VITE_BUILD || import.meta.env.REACT_APP_BUILD || '';

  resources.map((res) => {
    const resource = document.querySelector(`#${res.id}`) as HTMLLinkElement;
    if (resource) {
      resource.href = new URL(`${new URL(import.meta.url).origin}/${res.href}${`?domain=${domainTheme}`}${build ? `&build=${build}` : ''}`).toString();
    } else {
      const el: HTMLLinkElement = document.createElement('link');
      el.rel = res.rel;
      el.href = new URL(`${new URL(import.meta.url).origin}/${res.href}${`?domain=${domainTheme}`}${build ? `&build=${build}` : ''}`).toString();
      el.id = res.id;
      document.head.appendChild(el);
    }
  });
};
